import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { User } from '../../../models/User';
import { selectUserInfo } from '../../../main/store/User/reducer';
import { USERLANE_KEY } from '../../../constants/environment';
import { useUserLane } from '../../../hooks/useUserLane';

export const UserLaneClientConfig = () => {
    const user: User | undefined = useSelector(selectUserInfo);
    const { subscribeToNotifyOnComplete } = useUserLane();

    const [initialized, setInitialized] = useState<Boolean>(false);
    const domainRegexp = /.*@(.*)\.[\w]{2,3}/;

    const targetLicenses: Array<string> = ['business', 'business2020', 'business-plus-2020'];

    const isTargetLicense = (license: string): boolean => {
        return targetLicenses.indexOf(license) !== -1;
    };

    useEffect(() => {
        const cantInitializeUserLane = user?.userId && !initialized && !!window.Userlane;
        if (cantInitializeUserLane) {
            const userId = user?.userId;
            const userLang = user?.language;
            const regexpExec = domainRegexp.exec(user?.email);
            const domain = regexpExec && regexpExec.length ? regexpExec[1] : '';
            const codename = user?.codename;
            const userData = {
                license: isTargetLicense(codename!) ? codename : '',
                trial: user?.isTrial,
                offline: !user?.isOnlinePayment,
            };

            window.Userlane('init', USERLANE_KEY);
            window.Userlane('identify', userId, userData);
            window.Userlane('lang', userLang);
            window.Userlane('tag', domain);

            setInitialized(true);

            subscribeToNotifyOnComplete();
        }
    }, [user]);

    return null;
};
